import { t } from 'i18next';
import { useEffect, useState, useMemo, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { getTimbreList, GetTimbreListReq } from 'apis';
import InfiniteScroll from 'react-infinite-scroll-component';
import addCustomTaskIcon from 'assets/images/add-custom-task-icon.svg';
import { vhTypeMap } from 'pages/image_customization_manager/const';
import { Icon, Empty, Loading } from 'components/common';
import { Tabs, Spin, Input, Button, Dropdown, Menu } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { CloseCircleFilledIcon } from 'tdesign-icons-react';
import Filter from '../filter';
import './index.scss';
import TimbreItem from '../TimbreItem';
import { set } from 'lodash';
import useInView from './useInView';
import empty from './empty_content.svg';
import ImportThirdPartyTimbre from 'components/common/ImportThirdPartyTimbre';
interface Iprops {
  onSelect?: (value: any) => void;
  payload: any;
  tabKey: number;
  tryout: any;
  value: any;
  itemKey: number;
}
type TimbreFilter = {
  timbreGender?: number;
  timbreName: string;
  timbreDesc: string;
  timbreSelectedCode: string;
  timbreLanguageLabel: string;
  timbreSelectedLanguage?: string;
  timbreClassification: number;
  timbreAge?: number;
  thirdSource: string;
  thirdType?: number;
  timbrePlatformSource?: number;
};
type sideType = 'gender' | 'age' | 'timbreLanguage' | 'paymentType' | 'source' | 'platform';
const List = (props: Iprops) => {
  const navigate = useNavigate();
  const {
    onSelect,
    tabKey,
    payload: {
      timbreCategoryEnum,
      timbreLangugeList,
      virtualmanTypeCode,
      modelSource,
      virtualmanResourceId,
      virtualmanCode,
      timbreAuditionTextList,
    },
    itemKey,
    value,
    tryout,
  } = props;
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [timbreList, setTimbreList] = useState<any[]>([]);
  const [initLoading, setInitLoading] = useState(true);
  const [thirdTimbreImportVisible, setThirdTimbreImportVisible] = useState(false);
  const [loadingRef, bottomInViewport] = useInView<HTMLDivElement>();
  // 二级tab
  const timbreCategoryList = timbreCategoryEnum
    .filter((item: { dictCode: string }) => item.dictCode !== 'foreignlanguage' && item.dictCode !== 'custom')
    ?.map((item: any) => {
      return {
        value: item.dictValue,
        label: item.dictName,
      };
    });
  const [timbreCategory, setTimbreCategory] = useState(timbreCategoryList?.[0]?.value);
  const [timbreFilter, setTimbreFilter] = useState<TimbreFilter>({
    timbreClassification: tabKey,
    timbreName: '',
    timbreDesc: '',
    timbreSelectedCode: value?.timbreCode,
    timbreLanguageLabel: '',
    timbreSelectedLanguage: '',
    thirdSource: '',
    timbreGender: 0,
    timbreAge: 0,
    timbrePlatformSource: 0,
  });
  const [tryoutValue, setTryoutValue] = useState('');
  const throttleRef = useRef<NodeJS.Timeout | null>(null);
  const isRequestingRef = useRef(false);
  useEffect(() => {
    setOffset(0);
    setInitLoading(true);
    onNext(true);
  }, [timbreFilter, timbreCategory]);
  useEffect(() => {
    bottomInViewport && timbreList.length < totalCount && onNext();
  }, [bottomInViewport]);
  const [offset, setOffset] = useState(0);
  const importTts = () => {
    setThirdTimbreImportVisible(true);
  };
  const closeImportTtsModal = (isConfirm?: boolean) => {
    setThirdTimbreImportVisible(false);
    isConfirm && onNext(true);
  };
  const sex = [
    {
      value: 0,
      code: 0,
      name: t('全部'),
    },
    {
      code: 1,
      name: t('男性'),
      value: 1,
    },
    {
      code: 2,
      name: t('女性'),
      value: 2,
    },
  ];
  const sideTabDataSex = {
    type: 'gender' as sideType,
    value: sex,
    defaultcode: t('性别'),
  };
  const age = [
    {
      value: 0,
      code: 0,
      name: t('全部'),
    },
    {
      value: 1,
      code: 1,
      name: t('少年'),
    },
    {
      value: 2,
      code: 2,
      name: t('青年'),
    },
    {
      value: 3,
      code: 3,
      name: t('中年'),
    },
    {
      value: 4,
      code: 4,
      name: t('老年'),
    },
  ];
  const sideTabDataAge = {
    type: 'age' as sideType,
    value: age,
    defaultcode: t('年龄'),
  };
  const languageList = timbreLangugeList?.map((item: any) => ({
    code: item.dictCode,
    name: item.dictName,
    flag: item.flag,
  }));
  const newLanguageList = [
    {
      name: t('全部'),
      code: '',
      flag: '',
      value: '',
    },
  ].concat(languageList);
  const sideTabDataLanguage = {
    type: 'timbreLanguage' as sideType,
    value: newLanguageList,
    defaultcode: t('语种'),
  };
  const sideTabDataSource = {
    type: 'paymentType' as sideType,
    value: [
      {
        value: '',
        code: '',
        name: t('全部'),
      },
      {
        code: 'azure',
        name: t('微软Azure'),
        value: 'azure',
      },
      {
        code: 'google',
        name: t('Google TTS'),
        value: 'google',
      },
    ],
    defaultcode: t('三方来源'),
  };
  const sideTabDataFrom = {
    type: 'source' as sideType,
    value: [
      {
        value: 0,
        code: 0,
        name: t('全部'),
      },
      {
        code: 1,
        name: t('公共'),
        value: 1,
      },
      {
        code: 2,
        name: t('个人'),
        value: 2,
      },
    ],
    defaultcode: t('导入方'),
  };
  const platform = [
    {
      value: 0,
      code: 0,
      name: t('全部'),
    },
    {
      value: 1,
      code: 1,
      name: t('基础版'),
    },
    {
      value: 2,
      code: 2,
      name: t('极速版'),
    },
  ];
  const sideTabDataPlatform = {
    type: 'platform' as sideType,
    value: platform,
    defaultcode: t('定制类型'),
  };
  const refreshList = (timbreCode: string) => {
    const newList = timbreList.filter((item) => item.timbreCode !== timbreCode);
    setTotalCount(totalCount - 1);
    setTimbreList(newList);
  };
  const items = [
    {
      label: t('极速版声音定制'),
      key: vhTypeMap.zeroShotVoice.customType,
      value: vhTypeMap.zeroShotVoice.value,
      routePath: '/custom_sample_voice',
    },
    {
      label: t('基础版声音定制'),
      key: vhTypeMap.sampleTimbre.customType,
      value: vhTypeMap.sampleTimbre.value,
      routePath: '/custom_sample',
    },
  ];
  const getTimbreListByType = (payload: GetTimbreListReq) => {
    // if (type === 'photo') {
    //   return getProtoTimbreList(payload);
    // }
    return getTimbreList(payload);
  };
  const onCreateTryout = (value: string) => {
    setTryoutValue(value);
  };
  const isFilter = () => {
    return (
      timbreFilter?.thirdType ||
      timbreFilter?.timbreAge ||
      timbreFilter?.timbreGender ||
      timbreFilter?.timbreSelectedLanguage ||
      timbreFilter?.timbreName ||
      timbreFilter?.thirdSource ||
      timbreFilter?.timbrePlatformSource
    );
  };
  const onNext = useCallback(
    (isInit?: boolean) => {
      if (isRequestingRef.current) {
        return;
      }
      if (throttleRef.current) {
        clearTimeout(throttleRef.current);
      }
      throttleRef.current = setTimeout(() => {
        if (isRequestingRef.current) {
          return;
        }

        isRequestingRef.current = true;

        if (isInit) {
          setInitLoading(true);
          setTimbreList([]);
        } else {
          setLoading(true);
        }

        const payload = {
          offset: isInit ? 0 : timbreList.length,
          limit: 36,
          virtualmanTypeCode,
          ...(modelSource.includes('pcg_ai') ? { virtualmanResourceId } : { virtualmanCode }),
          timbreCategory,
          timbreFilter: {
            ...timbreFilter,
            timbreClassification: tabKey,
          },
        };

        getTimbreListByType(payload)
          .then(({ timbres, totalCount }) => {
            if (timbres.length === 0) {
              setTimbreList([]);
              setTotalCount(0);
              return;
            }
            let newTimbreList = [];
            if (isInit) {
              newTimbreList = timbres;
            } else {
              newTimbreList = [...timbreList, ...timbres];
            }
            setTimbreList(newTimbreList);
            setTotalCount(totalCount);
          })
          .catch(() => {})
          .finally(() => {
            setLoading(false);
            setInitLoading(false);
            isRequestingRef.current = false;
          });
      }, 300);
    },
    [
      timbreList,
      virtualmanTypeCode,
      modelSource,
      virtualmanResourceId,
      virtualmanCode,
      timbreCategory,
      timbreFilter,
      tabKey,
    ],
  );
  const changeCategory = (value: number | string) => {
    setTimbreCategory(value);
  };

  useEffect(() => {
    return () => {
      if (throttleRef.current) {
        clearTimeout(throttleRef.current);
      }
    };
  }, []);
  return (
    <div className="timbre-select-list">
      {tabKey !== 4 && (
        <div className="filter-tab">
          {tabKey === 1 && (
            <Tabs
              defaultActiveKey={timbreCategoryList?.[0]?.value}
              size="small"
              type="card"
              tabPosition="top"
              onChange={changeCategory}
              tabBarGutter={8}
            >
              {timbreCategoryList.map((item: { value: string; label: string }) => (
                <Tabs.TabPane tab={item.label} key={item.value} />
              ))}
            </Tabs>
          )}
          {tabKey !== 4 && (
            <div className="filter">
              <Input
                suffix={
                  <SearchOutlined
                    onClick={() => {
                      setOffset(0);
                      setInitLoading(true);
                      setTimbreList([]);
                      onNext(true);
                    }}
                  />
                }
                allowClear={{
                  clearIcon: (
                    <CloseCircleFilledIcon
                      onClick={() => {
                        setOffset(0);
                        setInitLoading(true);
                        setTimbreList([]);
                        onNext(true);
                      }}
                    />
                  ),
                }}
                placeholder={t('搜索音色名称/标签...')}
                onPressEnter={(e: any) => {
                  setTimbreFilter({
                    ...timbreFilter,
                    timbreName: e.target.value,
                  });
                }}
                onChange={(e) => {
                  if (!e.target.value) {
                    setTimbreFilter({
                      ...timbreFilter,
                      timbreName: '',
                    });
                  } else {
                    setTimbreFilter({
                      ...timbreFilter,
                      timbreName: e.target.value,
                    });
                  }
                }}
                style={{ width: 331, height: 34 }}
              />
              <div className="right">
                <Filter
                  simple={true}
                  showLabel={true}
                  sideTabData={sideTabDataSex}
                  handleSideVal={(data) => {
                    setTimbreFilter({
                      ...timbreFilter,
                      timbreGender: Number(data),
                    });
                  }}
                  needDisable={true}
                />
                {tabKey === 1 && (
                  <Filter
                    simple={true}
                    showLabel={true}
                    sideTabData={sideTabDataAge}
                    handleSideVal={(data) => {
                      setTimbreFilter({
                        ...timbreFilter,
                        timbreAge: Number(data),
                      });
                    }}
                    needDisable={true}
                  />
                )}
                {tabKey === 1 && (
                  <Filter
                    simple={true}
                    showLabel={true}
                    sideTabData={sideTabDataLanguage}
                    handleSideVal={(data) => {
                      setTimbreFilter({
                        ...timbreFilter,
                        timbreSelectedLanguage: String(data),
                      });
                    }}
                    needDisable={true}
                  />
                )}
                {tabKey === 3 && (
                  <Filter
                    simple={true}
                    showLabel={true}
                    sideTabData={sideTabDataFrom}
                    handleSideVal={(data) => {
                      setTimbreFilter({
                        ...timbreFilter,
                        thirdType: Number(data),
                      });
                    }}
                    needDisable={true}
                  />
                )}
                {tabKey === 3 && (
                  <Filter
                    simple={true}
                    showLabel={true}
                    sideTabData={sideTabDataSource}
                    handleSideVal={(data) => {
                      setTimbreFilter({
                        ...timbreFilter,
                        thirdSource: String(data),
                      });
                    }}
                    needDisable={true}
                  />
                )}
                {tabKey === 2 && (
                  <Filter
                    simple={true}
                    showLabel={true}
                    sideTabData={sideTabDataPlatform}
                    handleSideVal={(data) => {
                      setTimbreFilter({
                        ...timbreFilter,
                        timbrePlatformSource: Number(data),
                      });
                    }}
                    needDisable={true}
                  />
                )}
                {tabKey === 3 && (
                  <Button className="custom-task-header-btn" onClick={importTts}>
                    {t('导入TTS')}
                  </Button>
                )}
                {tabKey === 2 && (
                  <Dropdown
                    trigger={['click']}
                    overlay={
                      <Menu
                        items={items}
                        onClick={({ key }) => {
                          const selectedItem = items.find((t) => t?.key === +key) || items[0];
                          navigate(selectedItem.routePath, {
                            state: {
                              customItem: { key: +key, label: selectedItem?.label, value: selectedItem?.value },
                            },
                          });
                        }}
                      ></Menu>
                    }
                  >
                    <Button type="primary" className="custom-task-header-btn" icon={<img src={addCustomTaskIcon} />}>
                      {t('声音定制')}
                    </Button>
                  </Dropdown>
                )}
              </div>
            </div>
          )}
        </div>
      )}
      <div id={`scrollableTimbreList-${tabKey}`} className="timbre-select-wrapper">
        <Spin spinning={initLoading} className="loading"></Spin>
        {!initLoading && <>{timbreList.length ? (
          <div className="container">
            {timbreList.map((item) => (
              <TimbreItem
                timbre={item}
                value={value}
                onSelect={(value: any) => {
                  onSelect?.(value);
                }}
                timbreAuditionTextList={timbreAuditionTextList}
                key={item.timbreCode}
                tryout={tryout}
                tryoutValue={tryoutValue}
                onCreateDemo={onCreateTryout}
                languageList={languageList}
                timbreFilter={timbreFilter}
                refreshList={refreshList}
                tabKey={tabKey}
              ></TimbreItem>
            ))}
          </div>
        ) : !loading && !initLoading && !isFilter() && (tabKey === 2 || tabKey === 4) ? (
          <div className="empty">
            <div className="empty-wrap">
              <div className="empty-wrap-tit">
                {tabKey === 2 && t('您还没有定制音色，快来定制一个吧！')}
                {tabKey === 4 && t('您还没有收藏音色哦')}
              </div>
              {tabKey === 2 && (
                <div className="empty-wrap-opt">
                  <Button
                    type="primary"
                    className="custom-task-header-btn"
                    icon={<img src={addCustomTaskIcon} />}
                    onClick={() => {
                      const selectedItem = items[0];
                      navigate(selectedItem.routePath, {
                        state: {
                          customItem: {
                            key: selectedItem?.key,
                            label: selectedItem?.label,
                            value: selectedItem?.value,
                          },
                        },
                      });
                    }}
                  >
                    {items[0].label}
                  </Button>
                  <Button
                    type="primary"
                    className="custom-task-header-btn"
                    icon={<img src={addCustomTaskIcon} />}
                    onClick={() => {
                      const selectedItem = items[1];
                      navigate(selectedItem.routePath, {
                        state: {
                          customItem: {
                            key: selectedItem?.key,
                            label: selectedItem?.label,
                            value: selectedItem?.value,
                          },
                        },
                      });
                    }}
                  >
                    {items[1].label}
                  </Button>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="empty-ver">
            <img src={empty} className="empty-img" />
            <div className="empty-desc">{t('暂无内容')}</div>
          </div>
        )}
        {timbreList.length ? (
          <div ref={loadingRef} style={{ marginBottom: timbreList.length < totalCount ? '12px' : '0' }}>
            {timbreList.length < totalCount ? (
              <>
                <Loading />
              </>
            ) : (
              ''
            )}
          </div>
        ) : null}</>}
      </div>
      <ImportThirdPartyTimbre
        visible={thirdTimbreImportVisible}
        onCancel={()=>closeImportTtsModal(false)}
        onConfirm={() => closeImportTtsModal(true)}
      />
    </div>
  );
};
export default List;
